import { EmailMetaBuilder } from '@features/communications/components/EmailMetaBuilder'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/communication/email')({
  component: RouteComponent,
})

function RouteComponent() {
  return <EmailMetaBuilder />
}
